<template>
  <div :class="{ 'mb-2 counter': !viewList, 'ml-2 counterList': viewList }" v-if="surfacageDate && isDisconnected">
    <template v-if="viewList">(</template>
    {{ $t('Pilot.MissionDrawer.BackIn') }}
    <span v-if="!isConnected">----</span>
    <span v-else class="intime" :class="{ late: time > surfacageDate }">
      {{ [time, surfacageDate] | formatDuree($i18n, true) }}
    </span>
    <template v-if="viewList">)</template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch } from 'vue-property-decorator'
import CheckUnsaveChange from '@/components/shared/CheckUnsaveChange'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { MissionUi } from '../../models/ui/MissionUi'
import { GLIDER_MODE, AloMission } from '../../models/alo/AloMission'
import types from '@/store/all-mutation-types'
import { computeBackInDate, fixedPhasesMsAtCycle, FIXED_PHASE_SECTION_KEYS } from '@/utils/backInCalc'

@Component({
  name: 'MissionSurfacage',
  props: {
    mission: {
      type: AloMission,
    },
    viewList: {
      type: Boolean,
      default: false,
    },
  },
})
export default class MissionSurfacage extends Vue {
  mission!: AloMission
  viewList!: boolean
  time = new Date()
  timerID = -1

  /*Cycle de vie*/
  created() {
    this.timerID = setInterval(this.updateTime, 1000)
    this.ensureFixedPhaseSections()
  }

  beforeDestroy() {
    clearInterval(this.timerID)
  }

  get wasOfflineAfterLastBackin() {
    return (
      this.$store.myGetters.wasOffline &&
      this.connectedDate > this.mission.yoArray[this.mission.yoArray.length - 1].yoGpsDatTime.toISOString()
    )
  }

  get connectedDate() {
    return this.$store.myGetters.connectedDate
  }

  get isConnected() {
    return this.$store.myGetters.isConnected
  }

  get isDisconnected() {
    return this.mission.gliderWaitingMode == GLIDER_MODE.GLIDER_MODE_DISCONNECTED
  }

  get surfacageDate() {
    if (this.mission.misActifOn && this.mission.yoArray.length > 1) {
      // `computeBackInDate` renvoie `null` (jamais une Invalid Date) quand le
      // calcul n'est pas exploitable → repli sur la valeur serveur.
      return this.surfacageDateCalc ?? this.mission.backInDateTime
    }
  }

  /**
   * Charge les tables NMEA qui portent les durées des phases à durée fixe.
   *
   * Uniquement en vue détail : `MissionSurfacage` est aussi rendu sur chaque
   * ligne de la liste (`viewList`), où déclencher 4 fetch par mission serait
   * hors de proportion. En liste on lit seulement ce qui est déjà en store —
   * sans les sections, les phases valent 0 et on retrouve exactement la
   * formule d'avant.
   */
  ensureFixedPhaseSections() {
    if (this.viewList || !this.mission.misActifOn || this.mission.misId == null) return
    FIXED_PHASE_SECTION_KEYS.forEach(typeNmea => {
      this.$store.myActions.MISSION_ENSURE_DATA_NMEA({ typeNmea, id: this.mission.misId! })
    })
  }

  get surfacageDateCalc() {
    if (!this.mission.misActifOn) return null
    const sections = {
      seamrs: this.mission.dataNmea?.['seamrs'],
      seadrf: this.mission.dataNmea?.['seadrf'],
      seabtm: this.mission.dataNmea?.['seabtm'],
      seaflt: this.mission.dataNmea?.['seaflt'],
    }
    return computeBackInDate(this.mission.yoArray, cycle => fixedPhasesMsAtCycle(sections, cycle))
  }

  updateTime() {
    this.time = new Date()
  }
}
</script>

<style scope>
.counter {
  font-size: 16px;
  font-weight: bold;
}
.intime {
  color: #3d833d;
}
.late {
  color: #c71a1a;
}
.counterList {
  font-size: 10px;
}
</style>
